import React, { useEffect, useState } from "react";

import { DeviceType } from "../../hooks/use-breakpoint/device-type";
import useBreakpoint from "../../hooks/use-breakpoint/useBreakpoint";
import type { FeatureToggle, IconPack, ImageMap, ImageMapContent } from "../../models/app-data-model";
import "./image-map.scss";

export type ImageMapProps = {
  content: ImageMap;
};

const ImageMapContainer: React.FC<ImageMapProps> = ({ content }: ImageMapProps) => {
  const deviceType = useBreakpoint();
  const [imageMapContents, setImageMapContents] = useState<ImageMapContent | null>(null); // Use state to manage imageMapContents

  useEffect(() => {
    if (deviceType === DeviceType.Desktop) {
      setImageMapContents(content?.image_map_reference?.[0].desktop_image_contents);
    } else {
      setImageMapContents(content?.image_map_reference?.[0].mobile_image_contents);
    }
  }, [deviceType]);

  const imageMapCreator = imageMapContents?.image?.file.url ? (
    <img
      className="image-map-container"
      useMap={`#${imageMapContents?.map_name}`}
      src={imageMapContents?.image?.file.url}
      alt={imageMapContents?.image?.alt_text}
    />
  ) : null;

  return (
    <div className="image-map-contents">
      {imageMapCreator}
      {imageMapContents?.map_xml && <div dangerouslySetInnerHTML={{ __html: imageMapContents.map_xml.toString() }} />}
    </div>
  );
};

export default ImageMapContainer;
